import { render, staticRenderFns } from "./SaldoPL.vue?vue&type=template&id=52e55c62"
import script from "./SaldoPL.vue?vue&type=script&lang=js"
export * from "./SaldoPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports